export default __webpack_public_path__ + "static/media/loading.08d63e1a.gif";